export enum SqlDateModel {
  DATE = 'DD/MM/YYYY',
  DATE_TIME_12H = 'DD/MM/YYYY hh:mm:ss a',
  DATE_TIME_24H = 'DD/MM/YYYY HH:mm:ss',
  DATE_TIME = DATE_TIME_24H,
  FULL_DATE_TIME_12H = 'MMM DD, YYYY, hh:mm:ss a',
  FULL_DATE_TIME_24H = 'MMM DD, YYYY, HH:mm:ss',
  FULL_DATE_TIME = FULL_DATE_TIME_24H
}
